import React, { useEffect, useState } from 'react';
import { InboxAPI } from '../inbox.service';
import { KoButton, KoDateFormatter, KoDP, KoEmpty, KoLoader, KoModal, KoTable, KoText, KoTitle, KoToast } from 'packages';

import styles from './leaveApprove.module.scss';
import { useDispatch } from 'react-redux';
import { getApprovalCount } from 'shared/store/approvalCountSlice';
import { LEAVE_REQUESTBY, LEAVE_REQUEST } from '../constant';

export default function LeaveApproval() {
  const [isLoading, setLoading] = useState(false);
  const [requesters, setApprovelRequesters] = useState();
  const [waitingrequesters, setWaitingApprovelRequesters] = useState();
  const [selectedUser, setSelectedUser] = useState();
  const [currentRecord, setCurrentRecord] = useState();
  const [selectedRequests, setSelectedRequests] =useState();
  const [leaveList, setLeaveList] = useState();
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [openSubmitModal, setSubmitModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    getWaitingLeaves();
    getUsersList();
  }, []);



  useEffect(() => {
    if (selectedUser?.userId) {
      getLeaveRequests(selectedUser?.userId);
    }
  
  }, [selectedUser?.userId]);

  const getWaitingLeaves = () => {
    setLoading(true);
    InboxAPI.getWaitingLeaves().then(
      (data) => {
        setLoading(false);
        setWaitingApprovelRequesters(data['leaves']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getUsersList = (status) => {
    setLoading(true);
    InboxAPI.getUsersLeaveRequest().then(
      (data) => {
        setLoading(false);
        setApprovelRequesters(data['users']);
        setSelectedUser(data?.users?.length > 0 ? data?.users[0] : null);
        if(status){
          getLeaveRequests(data?.users[0]?.userId);
        }
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getLeaveRequests = (userId) => {
    setLoading(true);
    InboxAPI.getLeaveRequests(userId, { status:2 }).then(
      (data) => {
        setLoading(false);
        setLeaveList(data['leaves']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
    

  const canceLeaveRequest = () => {
    setLoading(true);
    let leaveObject = {};
    leaveObject['status'] = 3;
    leaveObject['approver'] = currentRecord?.approver;
    leaveObject['leaveId'] = selectedRequests?.length > 0 ? selectedRequests : [currentRecord?.leaveId];
    InboxAPI.rejectLeaveRequest(leaveObject, leaveObject?.leaveId).then(
      (data) => {
        getWaitingLeaves();
        setLoading(false);
        dispatch(getApprovalCount());
        setCancelConfirm(false);
        setSubmitModal(false);
        getUsersList(true);
        KoToast.success(`Request Rejected!`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const sendLeaveRequest = () => {
    setLoading(true);
    let leaveObject = {};
    leaveObject['status'] = 2;
    leaveObject['approver'] = currentRecord?.approver;
    leaveObject['leaveId'] = selectedRequests?.length > 0 ? selectedRequests : [currentRecord?.leaveId];
    InboxAPI.sendLeaveRequest(leaveObject).then(
      (data) => {
        getWaitingLeaves();
        getUsersList(true);
        setSelectedRequests();
        setLoading(false);
        setSubmitModal(false);
        dispatch(getApprovalCount());
        KoToast.success(`Approved successfully!`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onRowSelection = (record) => {
    setSelectedRequests(record);
  };

  
  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 200,
    render: (text, row) => {
      return <div className={`tableBtn columnsRight`} onClick={() => {  setCurrentRecord(row); }}>
        {row?.status === 1 && <KoButton  color="primary" variant="solid" label='Approve'  onClick={() => setSubmitModal(true)} />}
        {row?.status === 1 && <KoButton  color="danger" variant="solid" label='Reject' onClick={() => setCancelConfirm(true)} />}
      </div>;
    }
  }];

  return (
    <>
      <div className={`${styles.table}`}>
        <div className={styles.tableHeader}>
          <KoTitle text='Pending Leave Approvals' level={5} />
          { waitingrequesters?.length > 0 && <div className={styles.tableBtn}>
            <KoButton disabled={!selectedRequests ||selectedRequests?.length ===0} label="Approve" color="primary" variant="solid" onClick={() => setSubmitModal(true)} />
            <KoButton disabled={!selectedRequests || selectedRequests?.length ===0} label="Reject" color="danger" variant="solid" onClick={() => setCancelConfirm(true)} />
          </div>}
        </div>
        <div className={styles.tableList}>
          {waitingrequesters?.length > 0 ? <KoTable rowKey='leaveId' onRowSelection={onRowSelection}  extraColumnsRight={columnsRight} data={{ columns: LEAVE_REQUEST, rows: waitingrequesters }} maxHeight={35} />:
            <KoEmpty title="No pending leave approvals." subText=''/>}
        </div>
      </div>
      <div className={styles.wrapper}>
        {isLoading && <KoLoader />}
        <div className={styles.sideNav}>
          <KoTitle text='Your Team' level={5} />
          <div className={styles.sideNavList}>
            <ul>
              {requesters?.map((data, index) => {
                return (
                  <li className={selectedUser?.userId === data?.userId ? styles.active : ''} key={index} onClick={() => { setSelectedUser(data); }}>
                    <div className={`${styles.circle}  ${data ?
                      data?.profile?.firstName?.charAt(0).toLowerCase() : 'a'}`}>
                      {data?.profile?.['logo'] ?
                        <KoDP logo={data?.profile?.['logo']} className={styles.profile} width={30} height={30} />
                        :
                        <KoText className={`${styles.letter}`} text={data?.profile?.firstName?.charAt(0)} />}
                    </div>
                    <div className={styles.sideNavContent}>
                      <div className={styles.sideNavText} onClick={() => setSelectedUser({ userId: data?.userId, ...data?.profile })}>
                        <KoText ellipsis={true} text={`${data?.profile?.firstName}`} />
                        <KoText ellipsis={true} className={styles.email} text={data?.profile?.email} />
                      </div>
                      {/* {data?.waitingCount > 0 && <div className={styles.sideNavTextBadge}>
                        <KoText text={`${data?.waitingCount > 0 ? `${data?.waitingCount}` : ''}`} />
                      </div>} */}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className={styles.mainContent}>
          <KoTitle text='Leave Approved' level={5} />
          <div className={styles.wosList}>
            <KoTable rowKey='leaveRequest' data={{ columns: LEAVE_REQUESTBY, rows: leaveList }} maxHeight={100} />
          </div>
        </div>
        <KoModal
          title={`Reject Leave?`}
          centered
          open={cancelConfirm}
          afterClose={() => { setCurrentRecord(); }}
          handleOk={() => { setCurrentRecord(); setCancelConfirm(false); }}
          onClose={() => { setCurrentRecord(); setCancelConfirm(false); }}
          width={580}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setCancelConfirm(false)} />,
            <KoButton key='reset' color="danger" variant="solid" type='primary' label='Reject Leave' onClick={() => canceLeaveRequest(currentRecord)} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <div className={styles.suspend}>
            <KoTitle level={5} text={`Are you sure you want to Reject this Leave Request?`} />
            {currentRecord && <div className={styles.dates}>
              <KoDateFormatter data={currentRecord?.start} format="DD-MMM-YYYY" />
              <KoText text=" to " />
              <KoDateFormatter data={currentRecord?.end} format="DD-MMM-YYYY" />
              <KoText text={` - ${currentRecord?.reason} (${currentRecord?.totaldays} days)`} />
            </div>}
          </div>
        </KoModal>

        <KoModal
          title={`Approve Leave?`}
          centered
          open={openSubmitModal}
          afterClose={() => { setCurrentRecord(); }}
          handleOk={() => { setCurrentRecord(); setSubmitModal(false); }}
          onClose={() => { setCurrentRecord(); setSubmitModal(false); }}
          width={580}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setSubmitModal(false)} />,
            <KoButton key='reset'  type='primary' label='Approve Leave' onClick={() => sendLeaveRequest(currentRecord)} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <div className={styles.suspend}>
            <KoTitle level={5} text="Are you sure you want to Approve this leave request?" />
            {currentRecord && <div className={styles.dates}>
              <KoDateFormatter data={currentRecord?.start} format="DD-MMM-YYYY" />
              <KoText text=" to " />
              <KoDateFormatter data={currentRecord?.end} format="DD-MMM-YYYY" />
              <KoText text={` - ${currentRecord?.reason} (${currentRecord?.totaldays} days)`} />
            </div>}
          </div>
        </KoModal>
      </div>
    </>
  );
}
